<template>
    <bs5-base-modal title="Add New User" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="addUser">
                <div class="mb-3">
                    <bs5-base-label for="fullName">Full Name</bs5-base-label>
                    <bs5-base-input v-model="newUser.fullName" type="text" id="fullName" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="email" class="form-label">Email</bs5-base-label>
                    <bs5-base-input v-model="newUser.email" type="email" id="email" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="role" class="form-label">Role</bs5-base-label>
                    <select v-model.number="newUser.role" class="form-select" id="role">
                        <option v-for="(label, value) in userRoles" :key="value" :value="value">
                            {{ label }}
                        </option>
                    </select>
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button  @click="closeModal"/>
            <bs5-save-button @click="addUser" :loading="saving" />
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import userService from "@/services/user.service";
import { User } from "@/models/user.model"
import { UserRole } from "@/enums/user-role.enum";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "AddUserModal",
    props: {
        visible: { type: Boolean, required: true },
    },
    emits: ["close", "user-added"],
    data() {
        return {
            newUser: ref<User>({
                fullName: "",
                email: "",
                role: UserRole.Client,
            }),
            userRoles: {
                [UserRole.SuperAdmin]: "Super Admin",
                [UserRole.Distributor]: "Distributor",
                [UserRole.Client]: "Client",
            },
            saving: ref(false),
        };
    },
    methods: {
        async addUser() {
            try {
                this.saving = true;
                await userService.createUser(this.newUser);
                this.$emit("user-added");
                showToast("User added successfully!", "success");
                this.closeModal();
            } catch (error) {
                showToast("Failed to add user", "error");
                console.error("Error adding user:", error);
            }
            finally{
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>